import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  IconButton,
} from "@mui/material";
import { rsProgress } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooterLists } from "./UseFooterLists";
import { useNavigate, useLocation } from "react-router-dom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomPagination from "../../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../../../components/DeleteRow";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { readFromLS } from "../../../../util/LocalStrogeService";

export default function FooterLists(props) {
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetFooterList, RemoveFooterLists, SetFooterList } = UseFooterLists();
  const [listsRes, setListsRes] = useState();
  const [homePageId, setHomePageId] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : undefined
  );
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (props.expanded === "panel4") {
      setProgress(true);
      GetFooterList(homePageId?.id ? homePageId.id : 1, (Lists) => {
        setListsRes(Lists);
      });
    }
  }, [props.expanded, homePageId]);

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("panel4");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  useEffect(() => {
    if (props.expanded === "panel4") {
      const element = document.getElementById("panel4");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  }, [props.expanded]);

  const newFunc = () => {
    return navigate("/footerManage/addList", {
      state: {
        model: listsRes ? listsRes : [],
        expanded: props.expanded,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 100,
      align: "center",
      headerName: "اولویت",
      headerAlign: "center",
    },
    {
      field: "title",
      width: 250,
      align: "center",
      headerName: "عنوان",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 160,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  navigate("/footerManage/editList", {
                    state: {
                      model: cellValues.row,
                      expanded: props.expanded,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    id: cellValues.row.id,
                    name: cellValues.row.title,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  SetFooterList(model, () => {
                    GetFooterList(
                      homePageId?.id ? homePageId.id : 1,
                      (Certificates) => {
                        setListsRes(Certificates);
                      }
                    );
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex + 1,
                };

                if (cellValues.row.rowIndex + 1 == listsRes?.length + 1) {
                  return;
                } else {
                  SetFooterList(model, () => {
                    GetFooterList(
                      homePageId?.id ? homePageId.id : 1,
                      (Certificates) => {
                        setListsRes(Certificates);
                      }
                    );
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
  ];

  return (
    <Accordion
      expanded={props.expanded === "panel4"}
      id="panel4"
      onChange={handleChange("panel4")}
      style={{ marginTop: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel4")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel4bh-content"
        id="panel4bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            اطلاعات لیست ها
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ height: "30rem" }}>
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            pageSize={100}
            rows={listsRes ? listsRes : []}
            rowCount={listsRes?.length ? listsRes.length : 1}
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                newFunc: newFunc,
                isLtr: true,
                rowCount: listsRes?.length ? listsRes.length : "",
              },
            }}
          />
        </Box>
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"لیست"}
          callback={() => {
            setProgress(true);
            RemoveFooterLists(deleteState.id, () => {
              GetFooterList(homePageId?.id ? homePageId.id : 1, (Lists) => {
                setListsRes(Lists);
              });
            });
          }}
        ></DeleteRow>
      </AccordionDetails>
    </Accordion>
  );
}
